import React, { useState, useCallback, useMemo } from 'react'
import t from '~t'
import { useDispatch } from 'react-redux'
import { moveSelected } from '~data/actions/bookmarks'

import { Button, Icon } from '~ui'
import Picker from '~co/collections/picker'

export default function BookmarksSelectModeMove({ selectMode = {} }) {
    const dispatch = useDispatch()
    const [show, setShow] = useState(false)
    const { spaceId, all, ids = [] } = selectMode

    const onClick = useCallback(() => setShow(true), [])
    const onClose = useCallback(() => setShow(false), [])

    const events = useMemo(
        () => ({
            onItemClick: ({ _id }) => {
                dispatch(moveSelected(spaceId, _id))
                setShow(false)
            }
        }),
        [dispatch, spaceId]
    )

    return (
        <>
            <Button
                variant='outline'
                title={t.s('move')}
                disabled={!all && !ids.length}
                onClick={onClick}>
                <Icon name='move_to' />

                <span className='hide-on-small-body'>{t.s('move')}</span>
            </Button>

            {show ? (
                <Picker
                    events={events}
                    onClose={onClose} />
            ) : null}
        </>
    )
}
